import { useAppTheme } from "../theme/ThemeProvider";
import { ThemeMoonIcon, ThemeSunIcon } from "./ThemeIcons";
import "./app-theme-toggle.css";

type AppThemeToggleProps = {
  className?: string;
  showLabel?: boolean;
};

/** Single icon button: moon in light mode, sun in dark mode. */
export function AppThemeToggle({ className = "", showLabel = false }: AppThemeToggleProps) {
  const { effectiveTheme, setMode } = useAppTheme();
  const isDark = effectiveTheme === "dark";

  function toggleTheme() {
    setMode(isDark ? "light" : "dark");
  }

  return (
    <button
      type="button"
      className={`theme-icon-button${className ? ` ${className}` : ""}`}
      onClick={toggleTheme}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
    >
      <span key={effectiveTheme} className="theme-icon-button__glyph" aria-hidden="true">
        {isDark ? <ThemeSunIcon /> : <ThemeMoonIcon />}
      </span>
      {showLabel && (
        <span className="theme-icon-button__label">{isDark ? "Dark" : "Light"}</span>
      )}
    </button>
  );
}
